import { enumSchema } from "vue-utils"

export enum MarriageIncomeBand {
	Unsure = "Unsure",
	Unemployed = "Unemployed",
	LessThanEarningThreshold = "LessThanEarningThreshold",
	InThreshold = "InThreshold",
	MoreThanThreshold = "MoreThanThreshold",
	SomeYears = "SomeYears",
}

export const MarriageIncomeBandSchema = enumSchema(MarriageIncomeBand)

export function getIncomeBandDisplayText(band: MarriageIncomeBand) {
	switch (band) {
		case MarriageIncomeBand.Unsure:
			return "Not Sure"
		case MarriageIncomeBand.Unemployed:
			return "Unemployed"
		case MarriageIncomeBand.LessThanEarningThreshold:
			return "Earned less than £12,500"
		case MarriageIncomeBand.InThreshold:
			return "Earned between £12,500 and £100,000"
		case MarriageIncomeBand.MoreThanThreshold:
			return "Earned more than £100,000"
		case MarriageIncomeBand.SomeYears:
			return "Some years"
		default:
			return "Not Sure"
	}
}
